<template>
  <div class="business-plan">
    <div class="business-plan__type-wrapper">
      <Passes class="business-plan__icon" :passName="planName" :size="100" />
      <div class="business-plan__type">
        <p class="business-plan__type--header">Plan Type</p>
        <p class="business-plan__type--name">Business {{ planName }}</p>
      </div>
    </div>
    <div class="business-plan__message-wrapper">
      <p class="business-plan__message">
        The details of this subscription are only visible to the account owner.
      </p>
    </div>
  </div>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'

export default {
  name: 'BusinessPlan',
  components: { Passes },
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    planName() {
      const { plan } = this
      return plan?.plan?.name ?? 'Professional'
    },
  },
}
</script>

<style lang="scss">
.business-plan {
  display: flex;
  flex-wrap: wrap;
  background: var(--light-gray);
  padding: 20px 10px;
  justify-content: center;
  align-items: center;
  color: var(--white);
  @include mobile {
    padding: 25px;
    justify-content: space-evenly;
  }
  @include desktop {
    justify-content: space-between;
    flex-wrap: nowrap;
    padding: 50px;
  }
  &__type-wrapper {
    display: flex;
    align-items: center;
  }
  &__type {
    margin: 0 0 0 25px;
    &--header {
      font-size: rem(14px);
      color: var(--bright-gray);
      text-transform: uppercase;
      padding: 0 0 15px 0;
      margin: 0;
    }
    &--name {
      font-size: rem(24px);
      font-family: var(--font-bold);
      padding: 0 0 15px 0;
      margin: 0;
      max-width: 150px;
    }
  }
  &__message {
    font-size: rem(14px);
    color: var(--bright-gray);
    padding: 0;
    margin: 25px 0 0 0;
    max-width: 200px;
    @include desktop {
      max-width: 100%;
      margin: auto 0 0 0;
    }
  }
}
</style>
